import useMutationDocumentCreateUpdate from "./document-use-mutation-create-update";
import useMutationDocumentDelete from "./document-use-mutation-delete";
import useMutationDocumentOrder from "./document-use-mutation-order";

export const documentUseMutation = {
  createUpdate: useMutationDocumentCreateUpdate,
  delete: useMutationDocumentDelete,
  order: useMutationDocumentOrder,
};
